// extracted by mini-css-extract-plugin
export default {"root":"DocumentInformation_root__bTEz1","main":"DocumentInformation_main__1lbMc","title":"DocumentInformation_title__t1ifH","noData":"DocumentInformation_noData__OS3FU"};